/* eslint-disable import/prefer-default-export */
export const ArrayCheck = (data) => Array.isArray(data) && data.length > 0;

export const ArrayCheckWithLength = (array, length) => (
	Array.isArray(array) && array.length > (length || 3)
);
